module.exports = __webpack_public_path__ + "img/generate_white.c9b559b3.svg";